import uirouter from '@uirouter/angularjs';
import common from 'app/modules/common';

export default angular
  .module('app.holding.splash.legal.transfer', [
    common,
    uirouter,
  ])
  .name;

require('./services/transfer');
require('./states/transfer');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/splash/modules/legal/modules/transfer/index.js